import {
    BannerSliderStyles,
    bannerSlider
} from "@omni/ui/brand/bannerSlider/bannerSlider.styles";
import { Button } from "@omni/ui/components/Button/button.component";
import { ReactNode } from "react";

import { useSliderContext } from "@/components/BannerSlider/components/slider/context/slider.context";
import { useBannerSliderContext } from "@/components/BannerSlider/context/bannerSlider.context";

type Props = {
    type: "left" | "right";
    className?: string;
    children?: ReactNode;
};

export const NavButton = ({ type, className }: Props) => {
    const { stopTimer } = useBannerSliderContext();

    const { navigationNextRef, navigationPrevRef } = useSliderContext();

    const handleOnClick = () => {
        stopTimer();
    };

    const { slider_navButton, slider_navButton_icon } = bannerSlider();

    return (
        <Button
            ref={type === "right" ? navigationNextRef : navigationPrevRef}
            color={BannerSliderStyles.navButtonColor}
            className={slider_navButton({
                className: className
            })}
            onClick={handleOnClick}
        >
            <i className={slider_navButton_icon({ type: type })} />
        </Button>
    );
};
